import { isSameDay } from "date-fns";

import { TimeReportProjectItem } from "../types";

export const isSameTimeReportProjectItem = (payCodeGuid: string, date: Date) => (projectItem: TimeReportProjectItem) =>
  projectItem.payCode.guid === payCodeGuid && isSameDay(new Date(projectItem.date), date);
